import { CarListSort } from "@apac/components/cars";
import {
  CarList as CoreCarList,
  type CarListProps,
  CoreCarsComponent,
} from "@b2bportal/core-cars";

import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const CarList = ({ list, ...props }: CarListProps) => {
  const [block, cn] = useModuleBEM(styles, CoreCarsComponent.CarList);
  const { t } = useI18nContext();

  return (
    <div className={clsx(block, cn("container"))}>
      <div className={cn("header")}>
        <h1 className={cn("title")}>
          {t("core-cars.availability.title", {
            count: list.length,
          })}
        </h1>

        <CarListSort className={cn("sort-button")} />
      </div>
      <CoreCarList list={list} {...props}>
        {props.children}
      </CoreCarList>
    </div>
  );
};
